import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { Box, Button, Flex, Text } from "pcln-design-system";
import { useContext, useEffect, useRef } from "react";
import { otpDeliveryMechanisms } from "../../constants/index.js";
import { ChatbotDataContext } from "../../context/ChatbotDataContext.js";
import { useOtpContext } from "../../context/OtpContext.js";
import { TravelBotLogoImage } from "../../TravelBotLogoImage.js";
import { ChatMessage } from "../CustomChatMessage/index.js";
import MessageFooter from "../MessageFooter/MessageFooter.js";
import OtpForm from "../OtpForm/OtpForm.js";
import PennyChatBubble from "../PennyChatBubble/index.js";
import VerificationCode from "../VerificationCode/VerificationCode.js";
import ErrorComponent from "./ErrorComponent.js";
const otpDeliveryChoiceChips = [
    {
        name: 'Phone (SMS)',
        size: 'medium',
        variation: 'subtle',
        deliveryMechanism: otpDeliveryMechanisms.SMS,
        styling: {
            mr: 2
        }
    },
    {
        name: 'Email',
        size: 'medium',
        variation: 'subtle',
        deliveryMechanism: otpDeliveryMechanisms.EMAIL_ONLY_OTP,
        styling: {}
    }
];
const FindMyTrips = ({ message })=>{
    const messageEndRef = useRef(null);
    const { setiValues } = useContext(ChatbotDataContext);
    const { setOtpDeliveryType, otpDeliveryType, otpDeliveryMethodUsed, setOtpFormData, showOtpVerificationForm } = useOtpContext();
    const deliveryDestination = otpDeliveryMethodUsed === otpDeliveryMechanisms.SMS ? 'phone number' : 'email address';
    useEffect(()=>{
        setOtpFormData(void 0);
    }, []);
    useEffect(()=>{
        messageEndRef.current?.scrollIntoView({
            behavior: 'smooth'
        });
    }, [
        showOtpVerificationForm
    ]);
    const content = /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(Text, {
                mb: 3,
                children: "To help with your trip, just confirm the details linked to your booking. We'll send a quick verification code so we can unlock your itinerary."
            }),
            /*#__PURE__*/ jsx(Text, {
                mb: 3,
                children: "Choose how you'd like to receive it:"
            }),
            /*#__PURE__*/ jsx(Flex, {
                mb: 3,
                children: otpDeliveryChoiceChips.map((choiceChip)=>/*#__PURE__*/ jsx(Button, {
                        size: choiceChip.size,
                        variation: choiceChip.variation,
                        ...choiceChip.styling,
                        onClick: ()=>setOtpDeliveryType(choiceChip.deliveryMechanism),
                        children: choiceChip.name
                    }))
            }),
            showOtpVerificationForm ? /*#__PURE__*/ jsxs(Text, {
                fontWeight: 'bold',
                children: [
                    "We've sent a verification code to the ",
                    deliveryDestination,
                    " provided."
                ]
            }) : otpDeliveryType ? /*#__PURE__*/ jsx(OtpForm, {}) : null
        ]
    });
    const verificationContent = /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsxs(Text, {
                mb: 3,
                children: [
                    "Please enter the code sent to the ",
                    deliveryDestination,
                    " provided. "
                ]
            }),
            /*#__PURE__*/ jsx(VerificationCode, {})
        ]
    });
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(Flex, {
                mb: 4,
                children: setiValues?.shouldEnablePortalUpdates ? /*#__PURE__*/ jsx(PennyChatBubble, {
                    message: message,
                    children: content
                }) : /*#__PURE__*/ jsx(ChatMessage, {
                    ml: "",
                    mb: "20px",
                    variation: 'initial',
                    Icon: TravelBotLogoImage,
                    message: content,
                    footer: /*#__PURE__*/ jsx(MessageFooter, {})
                })
            }),
            showOtpVerificationForm ? /*#__PURE__*/ jsx(Flex, {
                mb: 4,
                children: setiValues?.shouldEnablePortalUpdates ? /*#__PURE__*/ jsx(PennyChatBubble, {
                    message: message,
                    children: verificationContent
                }) : /*#__PURE__*/ jsx(ChatMessage, {
                    ml: "",
                    mb: "20px",
                    variation: 'initial',
                    Icon: TravelBotLogoImage,
                    message: verificationContent,
                    footer: /*#__PURE__*/ jsx(MessageFooter, {})
                })
            }) : null,
            /*#__PURE__*/ jsx(ErrorComponent, {}),
            /*#__PURE__*/ jsx(Box, {
                ref: messageEndRef
            })
        ]
    });
};
const FindMyTrips_FindMyTrips = FindMyTrips;
export { FindMyTrips_FindMyTrips as default };
